import "./sentry";  // must be first — initializes Sentry before React mounts
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";  //import tailwindcss to use tailwindcss classes
import { Toaster } from "sonner";
import { isChunkLoadError, reloadOnceForStaleChunks } from "./utils/chunkReload";

// Recover automatically when a stale chunk (from a previous deploy) fails to load.
// Vite emits `vite:preloadError` for failed module preloads / dynamic imports;
// we also catch generic load errors and unhandled rejections as a backstop.
window.addEventListener("vite:preloadError", () => reloadOnceForStaleChunks());
window.addEventListener("error", (e) => {
  if (isChunkLoadError(e?.message)) reloadOnceForStaleChunks();
});
window.addEventListener("unhandledrejection", (e) => {
  const reason = e?.reason;
  const msg = reason instanceof Error ? reason.message : String(reason ?? "");
  if (isChunkLoadError(msg)) reloadOnceForStaleChunks();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 32, fontFamily: 'system-ui' }}>
          <h2>Something went wrong</h2>
          <p style={{ color: '#888' }}>
            We've been notified and are looking into it. You can try again or reload the page.
          </p>
          <pre style={{ background: '#f5f5f5', padding: 12, borderRadius: 4, fontSize: 12, overflow: 'auto' }}>
            {error instanceof Error ? error.message : String(error)}
          </pre>
          <button onClick={resetError} style={{ marginRight: 8 }}>Try again</button>
          <button onClick={() => window.location.reload()}>Reload page</button>
        </div>
      )}
    >
      <App />
      <Toaster position="top-right" richColors />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
